export enum PageType {
  PaymentComponent = 'payment component',
  SDK = 'sdk',
}
